<!--
 * @Author: gongzhichao
 * @Date: 2023-04-17 00:00:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 影音视听
-->
<template>
  <div class="main">
    <SecondPage>
      <div class="media">
        <div class="tab">
          <ul>
            <li
              :class="index == tabIndex ? 'tab-active' : 'tab-def'"
              v-for="(item, index) in $config.mediaTab"
              :key="item.id"
              @click="tabClick(item, index)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="content">
          <div
            class="picture"
            v-if="tabIndex == 1 || tabIndex == 2"
            v-loading="loading"
          >
            <el-image
              class="myimage"
              style="width: 421px; height: 242px"
              v-for="(item, index) in mediaImageList.slice(0, pageSize)"
              :src="item.imgStr"
              :key="index"
              :preview-src-list="mediaSrcList"
            >
            </el-image>
          </div>
          <div v-else>
            <div class="video-inside">
              <video
                poster="../../../assets/video/poster.png"
                ref="videoPlayer"
                src="../../../assets/video/video-inside.mp4"
                muted
                controls
              ></video>
            </div>
          </div>
        </div>
        <!-- <div class="test">
          <el-pagination
            v-if="tabIndex != 0"
            hide-on-single-page
            background
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :total="pageTotel"
            layout="prev, pager, next"
            prev-text="<"
            next-text=">"
          ></el-pagination>
        </div> -->
      </div>
    </SecondPage>
  </div>
</template>

<script>
import SecondPage from "../component/SecondPage/SecondPage.vue";
import webSiteHigh from "../../../api/webSiteHigh";
export default {
  metaInfo: {
    title: "影音视听",
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },
  components: { SecondPage },
  data() {
    return {
      loading: false,
      tabIndex: "",
      pageSize: 6,
      pageTotel: "",
      currentPage: 1,
      mediaSrcList: [],
      mediaImageList: [],
      mediaImageListCopy: [],
    };
  },

  watch: {
    "$route.query": {
      async handler(newVal, oldVal) {
        if (newVal.title != oldVal.title) location.reload();
      },
    },
    deep: true,
  },
  // 组件路由守卫
  beforeRouteEnter(to, from, next) {
    document.title = "";
    let { title } = to.query;
    if (to.meta.title) document.title = title;
    next();
  },
  async mounted() {
    let { tab } = this.$route.query;
    this.tabClick(null, tab);
    this.handleCurrentChange(1);

  },
  methods: {

    // tab - 影音视听
    async   tabClick(item, index) {
      let list = [];
      this.tabIndex = index;
      switch (Number(index)) {
        case 1:{
            let gameType="精美壁纸"
         let res = await webSiteHigh.searchGameData(gameType);
           this.mediaSrcList = res.data[0].strategyEntity;
           list=  this.mediaSrcList
          break;
        }
        case 2:{
          
      let game="游戏截图"
      let resGame = await webSiteHigh.searchGameData(game);
       this.mediaImageList = resGame.data[0].strategyEntity;
       list=  this.mediaImageList
          break;
        }

         
        default:
        list = [];
          break;
      }
      this.mediaSrcList = list.map((e) => e.imgStr);
      this.mediaImageList = list;
      this.mediaImageListCopy = JSON.parse(JSON.stringify(list));
      this.pageTotel = this.mediaImageListCopy.length;
      this.currentPage = 1;
    },
    // async  getMediaList() {
   
    //   let gameType="精美壁纸"
    //  let res = await webSiteHigh.searchGameData(gameType);
    //    this.mediaSrcList = res.data[0].strategyEntity;

    
    //   let game="游戏截图"
    //   let resGame = await webSiteHigh.searchGameData(game);
    //    this.mediaImageList = resGame.data[0].strategyEntity;

     
    // },

    // 分页
    handleCurrentChange(val) {
      this.loading = true;
      setTimeout(() => {
        this.mediaImageList = this.mediaImageListCopy.slice(
          (val - 1) * this.pageSize,
          val * this.pageSize
        );
        this.loading = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  .media {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1385px;
    height: auto;
    margin-top: 92px;
    .tab {
      width: 100%;
      height: 79px;
      border-bottom: 3px solid #b5a495;
      ul {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        li {
          width: 195px;
          height: 63px;
          font-size: 30px;
          line-height: 55px;
          text-align: center;
          margin: 0 7px;
          background-size: 100% 100%;
          font-size: 36px;
          cursor: pointer;
        }
        .tab-def {
          color: #643e22;
        }
        .tab-active {
          color: #ffffff;
          background: url("~@/assets/image/pc/basemap-secend-tab-active.png")
            no-repeat center;
        }
      }
    }
    .content {
      width: 100%;
      height: 524px;
      margin-top: 47px;
      .picture {
        height: 524px;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        .myimage {
          margin-left: 30px !important;
          /deep/.el-image-viewer__wrapper {
            position: absolute;
            .el-image-viewer__canvas {
              position: absolute;
              height: 80%;
              top: 10%;
            }
            /deep/span {
              .el-image-viewer__close {
                top: 50% !important;
              }
            }
          }
        }
        .el-image-viewer__close {
          top: 10%;
        }
      }

      .video-inside {
        video {
          width: 865px;
          height: 520%;
        }
      }
    }
    .test {
      margin-top: 32px;
      /deep/ .el-pagination button {
        width: 52px;
        height: 52px;
      }
      /deep/ .el-pagination span {
        width: 52px;
        height: 52px;
        font-size: 24px;
        line-height: 52px;
      }

      /deep/ .el-pagination .el-pager li {
        width: 52px;
        height: 52px;
        line-height: 52px;
      }

      /deep/ .el-pagination button:disabled {
        background: transparent;
        background-color: #e5e1d9;
        span {
          color: #643e22;
          font-weight: 700;
        }
      }
      /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #e8ce98;
      }
      /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
        background-color: #e5e1d9;
      }
      /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #643e22;
      }
    }
  }
}
</style>
